import { render } from "./want.vue?vue&type=template&id=5a0abdee&ts=true"
import script from "./want.vue?vue&type=script&lang=ts"
export * from "./want.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__